import React, { useState } from 'react'

import ProgressBar from 'APP/Components/ProgressBar'

import {
  SearchContainer,
  ContentContainer,
  StyledSearchField,
  ButtonContainer,
  StyledScrollView,
} from './style'
import { isWeb } from 'APP/Helpers/checkPlatform'
import Button from 'APP/Converse/Button'
import SemanticSearch from 'APP/Converse/SemanticSearch'
import SemanticSearchTrigger from './SemanticSearchTrigger'
import { Props } from './types'

const SearchCard = (props: Props) => {
  const {
    placeholder,
    disabled,
    running,
    content,
    style,
    ctaTitle,
    ctaOnPress,
    ctaDisabled,
    ctaOnCancel,
  } = props

  const [semanticSearchIsVisible, setSemanticSearchIsVisible] = useState(false)

  const handleClose = () => {
    setSemanticSearchIsVisible(false)
  }

  const Header = (
    <SearchContainer>
      {props.useSemanticSearch ? (
        <SemanticSearchTrigger
          handleOpen={() => setSemanticSearchIsVisible(true)}
          placeholder={placeholder}
        />
      ) : (
        <StyledSearchField
          placeholder={placeholder}
          showClearButton={props.searchTerm.length > 0}
          onClearButtonPress={props.onClearSearchButtonPress}
          disabled={disabled}
          value={props.searchTerm}
          onChange={props.onTextChange}
        />
      )}
      <ProgressBar total={1} current={1} processing show={running} />
    </SearchContainer>
  )

  const Content = isWeb() ? (
    <>
      {content}
      {ctaOnPress && ctaTitle && (
        <ButtonContainer>
          {ctaOnCancel && <Button testID="CANCEL_BUTTON" title="cancel" onPress={ctaOnCancel} />}
          <Button
            testID="SUBMIT_BUTTON"
            title={ctaTitle}
            onPress={ctaOnPress}
            disabled={ctaDisabled}
          />
        </ButtonContainer>
      )}
    </>
  ) : (
    <StyledScrollView>
      {Header}
      {content}
      {ctaOnPress && ctaTitle && (
        <ButtonContainer>
          {ctaOnCancel && <Button testID="CANCEL_BUTTON" title="cancel" onPress={ctaOnCancel} />}
          <Button
            testID="SUBMIT_BUTTON"
            title={ctaTitle}
            onPress={ctaOnPress}
            disabled={ctaDisabled}
          />
        </ButtonContainer>
      )}
    </StyledScrollView>
  )

  return (
    <ContentContainer style={style}>
      {isWeb() && Header}
      {Content}
      {props.useSemanticSearch && (
        <SemanticSearch
          isOpen={semanticSearchIsVisible}
          onClose={handleClose}
          searchSource={props.searchSource}
          groupL1Categories={props.groupL1Categories}
          choices={props.choices}
          onSearchChoiceSelected={props.onChoicePress}
        />
      )}
    </ContentContainer>
  )
}

export default SearchCard
